import { useEffect, useState, useMemo } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { formatDate, handleErrorMessages } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';

const InvoicesUpdate = ({ open, onClose, reload, currentItem, chartsAccountList, bankInformation,selectedItem ,amount_paid}) => {
    // console.log("🚀 ~ InvoicesUpdate ~ selectedItem:", selectedItem)
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const NewUserSchema = Yup.object().shape({
    });
    const defaultValues = useMemo(
        () => ({
            account_chart_id: currentItem?.account_chart_id || '',
            amount: selectedItem?.amount_received || '',
        }),
        [currentItem, selectedItem]
    );
    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues,
    });
    const {
        reset,
        setValue,
        handleSubmit,
        errors,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [currentItem, reset, defaultValues]);

    const onSubmit = handleSubmit(async (data) => {
        console.log('Form data submitted:', data);
        setLoading(true);
        const formData = new FormData();
        formData.append('amount_received', data.amount);
        formData.append(data.credit === 'Credit' ? 'credit' : 'debit', data.credit === 'Credit' ? '1' : '0');
        formData.append('account_chart_id', data.account_chart_id?.id);
        formData.append('bank_information_id', data?.bank_information_id?.id);
        try {
            const response = await postRequest(
                `${endpoints.accounting.account_receiveable.invoice.update_invoice}/${currentItem.id}/follow-up/${selectedItem.id}`,
                formData,
                true,
            );
            if (response.metadata && response.metadata.success) {
                reset();
                reload();
                onClose();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response?.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });
    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            fullWidth
            maxWidth="md"
            sx={{
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            }}
            transitionDuration={{
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            }}
        >
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxSizing: 'content-box' }}>
                    <span className='cardColor' style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}>
                        &nbsp;&nbsp;  Invoice Update  &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={onClose}>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{
                        borderRadius: '1px',
                    }}
                >
                    <Box
                        mt={2}
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(2, 2fr)',
                        }}
                    >
                        <RHFTextField name="amount" type="number" label="Amount" disabled />
                        <RHFAutocomplete
                            name="credit"
                            label="Credit/Debit"
                            options={['Credit', 'Debit']}
                            getOptionLabel={(option) => option}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option}>
                                    {option}
                                </li>
                            )}
                            onChange={(_, value) => {
                                methods.setValue('credit', value);
                            }}
                            error={!!methods.formState.errors.credit}
                            helperText={methods.formState.errors.credit?.message}
                        />
                        <RHFAutocomplete
                            name="bank"
                            label="Name of Bank"
                            options={bankInformation}
                            onChange={(_, value) => {
                                setValue('bank_information_id', value)
                            }}
                            getOptionLabel={(option) => option?.bank_name || ''}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.bank_name}
                                </li>
                            )}
                        // error={!!errors.bank}
                        // helperText={errors.bank?.message}
                        />
                        <RHFAutocomplete
                            name="account_chart_id"
                            label="Charts of Account"
                            options={chartsAccountList}
                            getOptionLabel={(option) => option?.code || ''}
                            isOptionEqualToValue={(option, value) => option.id === value.id}  // Ensure correct matching by ID
                            renderOption={(props, option) => <li {...props} key={option.id}>
                                {option.code}-{option.name}-{option.account_type?.name}
                            </li>}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={onClose}>
                        Cancel
                    </Button>
                    <LoadingButton type="submit" variant="contained" className='dark-button' loading={isSubmitting}>
                        {!currentItem || !currentItem.id ? 'Create Invoice' : 'Update Invoice'}
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};
export default InvoicesUpdate;